module.exports = __webpack_public_path__ + "img/商务合作banner@2x.1f3d3b21.png";